import React from "react";
import Chevron from "../../../assets/icons/Chevron.svg";
import { Link } from "gatsby";

interface ICardDetail {
  icon?: React.ReactNode;
  text: string;
  link?: string;
  textStyle?: string;
  chevronStyle?: string;
  className?: string;
}

const CardDetail = ({
  icon,
  text,
  link,
  textStyle,
  chevronStyle,
  className,
}: ICardDetail) => {
  return (
    <Link
      className={`w-fit flex flex-row flex-nowrap items-center ${
        link ? "cursor-pointer" : "cursor-default"
      } ${className}`}
      to={link ?? ''}
    >
      {icon && <div className="pr-2">{icon}</div>}
      <p className={`${textStyle}`}>{text}</p>
      {link && (
        <div className="pl-2">
          <Chevron className={chevronStyle} />
        </div>
      )}
    </Link>
  );
};

export default CardDetail;
